import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Gallery from '../views/Gallery.vue'
import LocationHS from '../views/LocationHS.vue'
import TestimonialHS from '../views/TestimonialHS.vue'
import OnlineShop from '../views/OnlineShop.vue'
import Services from '../views/Services.vue'
import About from '../views/About.vue'
// appointment
import Appointment from '../views/Appointment.vue'

// login
import Authenticate from '../views/Authenticate.vue'

// Admin
import AdminLogin from '../views/AdminLogin.vue'
import AdminDashboard from '../views/admin/AdminDashboard.vue'
import AdminProfile from '../views/admin/AdminProfile.vue'
import ManageGallery from '../views/admin/ManageGallery.vue'
import ManageServices from '../views/admin/ManageServices.vue'
import RegisterStylist from '../views/admin/RegisterStylist.vue'

//Stylist
import StylistAuthenticate from '../views/stylist/StylistAuthenticate.vue'
import StylistDashboard from '../views/stylist/StylistDashboard.vue'
import StylistProfile from '../views/stylist/StylistProfile.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: Gallery
  },
  {
    path: '/location',
    name: 'location',
    component: LocationHS
  },
  {
    path: '/testimonial',
    name: 'testimonial',
    component: TestimonialHS
  },
  {
    path: '/services',
    name: 'services',
    component: Services
  },
  {
    path: '/shop',
    name: 'onlineShop',
    component: OnlineShop
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },

  // appointment
  {
    path: '/appointments/:appointmentId/manage',
    name: 'AppointmentManager',
    component: Appointment
  },

  {
    path: '/appointment',
    name: 'AppointmentBooking',
    component: Appointment
  },

  // login
  {
    path: '/authenticate',
    name: 'Authenticate',
    component: Authenticate
  },

  {
    path: '/admin/dashboard',
    name: 'adminDashboard',
    component: AdminDashboard,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
    const adminData = localStorage.getItem('adminUser');
  const user = adminData ? JSON.parse(adminData) : null;

  // Check if the route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!user || !user.access_token) {
      next({ name: 'Authenticate' });
    } else {
      next();
    }
  } else {
    next();
  }
    }
  },
  {
    path: '/admin/profile',
    name: 'adminProfile',
    component: AdminProfile
  },
  {
    path: '/admin/services', 
    name: 'adminServices',
    component: ManageServices
  },
  {
    path: '/admin/gallery',
    name: 'adminGallery',
    component: ManageGallery
  },
  {
    path: '/admin/register',
    name: 'registerStylist',
    component: RegisterStylist
  },

  {
    path: '/stylist/dashboard',
    name: 'StylistDashboard',
    component: StylistDashboard,
    beforeEnter: (to, from, next) => {
    const data = localStorage.getItem('salon_auth');
    if (!data) return next({ name: 'Authenticate' });

    const session = JSON.parse(data);
    const isStylist = session.role === 'stylist';
    const googleRequired = session.loginResponse?.google_auth_required;

    if (isStylist && googleRequired) {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('google_auth') === 'success') {
            next();
        } else {
            // back to login because they haven't finished the process
            next({ name: 'Authenticate', query: { error: 'reauth_required' } });
        }
    } else {
        next(); 
    }
  }
  },
  {
    path: '/stylist/profile',
    name: 'StylistProfile',
    component: StylistProfile
  },

  {
    path: '/payment-success',
    name: 'PaymentSuccess',
    component: Services
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
